import t from "./index890.js";
import o from "./index891.js";
import f from "./index812.js";
import i from "./index795.js";
import e from "./index852.js";
function c(r) {
  return typeof r == "function" ? r : r == null ? f : typeof r == "object" ? i(r) ? o(r[0], r[1]) : t(r) : e(r);
}
export {
  c as default
};
